// extracted by css-extract-rspack-plugin
export default {"summaryContainer":"PullRequestHeaderSummary-module__summaryContainer__dA7dP"};